import { render, staticRenderFns } from "./NewTender.vue?vue&type=template&id=77beb096&scoped=true"
import script from "./NewTender.vue?vue&type=script&lang=js"
export * from "./NewTender.vue?vue&type=script&lang=js"
import style0 from "./NewTender.vue?vue&type=style&index=0&id=77beb096&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77beb096",
  null
  
)

export default component.exports